import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/store/auth-store';
import { OAuthConsentPage } from '@/features/oauth/components/OAuthConsentPage';

/**
 * `/oauth/consent` — la pantalla donde el humano aprueba que su ChatGPT o
 * Claude acceda al workspace por el servidor MCP.
 *
 * VA EN EL TOP LEVEL, no bajo `_auth/`: el `DashboardLayout` no corresponde
 * para una pantalla a la que se llega desde afuera y que existe sólo para
 * tomar una decisión. Mismo patrón que `/onboarding`.
 *
 * PERO SÍ EXIGE SESIÓN, porque el POST del consentimiento sale con el JWT del
 * usuario. Si no hay token se manda al login preservando la URL ENTERA: acá
 * ese detalle no es comodidad, es lo único que evita romper el flujo — el
 * query string lleva `state`, `code_challenge` y `redirect_uri` del cliente
 * MCP, que no existen en ningún otro lado. `login.tsx` lee ese `redirect`
 * (hasta hoy nadie lo leía) y lo filtra a mismo origen.
 */
export const Route = createFileRoute('/oauth/consent')({
  beforeLoad: ({ location }) => {
    if (!useAuthStore.getState().token) {
      // La URL CRUDA del navegador, no la re-serializada del router. A esta
      // ruta SIEMPRE se entra por carga de documento completa (el backend
      // responde un 302), así que `window.location` es autoritativo y conserva
      // los parámetros byte por byte — que es justo lo que el contrato exige y
      // lo que el router no garantiza al re-armar el search.
      const url = typeof window !== 'undefined' ? window.location.href : location.href;
      throw redirect({ to: '/login', search: { redirect: url } });
    }
  },
  component: OAuthConsentPage,
});
